import React from 'react'

const InterviewHired = () => {
  return (
    <>
    <div className="int-hired">
        <div className="interview">
                <span>
                    <i className="fa-solid fa-people-group fa-2xl"></i>
                </span>
            <div>
                <h1>246</h1>
                <p>Interviews</p>
            </div>
            <i className="fa-solid fa-chart-bar fa-2xl"></i>
        </div>
        <div className="interview">
                <span>
                    <i className="fa-solid fa-hand-holding-hand fa-2xl"></i>
                </span>
            <div>
                <h1>101</h1>
                <p>Hired</p>
            </div>
            <i className="fa-solid fa-chart-simple fa-2xl"></i>
    </div>
    </div>
    </>
  )
}

export default InterviewHired